import { Injectable, Optional } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  HttpErrorHandlerService,
  HandleError,
} from '../config/http-error-handler.service';
import { BaseSvcService } from '../config/base-svc.service';
import { AppOfflineStore } from '../../app.offlineService';
import { HttpRequest, HttpEvent } from '@angular/common/http';
import { SessionService } from '../session.service';
import { ICoursePlanMockExam, IMockExam, IPracticeTest } from 'src/app/Models/ExamAgencies';


export interface IGetQuestionForPracticeTestRequest {
  LoggedInUser?: string
  CourseId: number
  CourseTestId: number
  NumberOfQuestions: number
  QuestionID: string | null
}

export interface IInsertUpdateWeeklyPracticeTestStudyUnit {
  LoggedInUser?: string
  CourseTestId: number
  UDTPracticeTestStudyUnit: UdtpracticeTestStudyUnit[]
}

export interface UdtpracticeTestStudyUnit {
  StudyUnitID: number
  SelectedIND: string
}


export interface IGetMockExamQuestionRequest {
  LoggedInUser?: string;
  CourseTestId: number;
  CourseId: number;
  SubjectID: number;
  NumberOfQuestions: number;
}

export interface IGetMockExamApplicableCoursePlanResponse {
  examAgencyID?: number;
  examAgencyName: string;
  courseTestId?: number;
  courseMasterId?: number;
  courseName: string;
  coursePlanID?: number;
  courseID?: number;
  examYear?: number;
  deletedInd: string;
  testTypeCode: string;
  coursePlanTypeCode: string;
  Deleted_Ind: string;
}

export interface IMockExamRequest {
  LoggedInUser?: string;
  CalledFrom: string | null;
  CourseID: number;
  CoursePlanID: number | null;
  MockExamID: number | null;
}
export interface IWeeklyPracticeTestRequest {
  LoggedInUser?: string;
  CalledFrom: string | null;
  CourseID: number;
  CoursePlanID: number | null;
  PracticeTestID: number | null;
}
export interface IApplicableCoursePlan {
  CoursePlanID: number;
  SelectedInd: string;
}

export interface IMockExampayload {
  CourseId: number;
  CourseTestId?: number | null;
  CourseTestStatusTypeCode: string;
  ErrorMessage?: string;
  ExamSeriesTypeCode: string;
  LoggedInUser?: string;
  NewCourseTestId?: number;
  StudentId?: number | null;
  SuccessInd?: string;
  TestName?: string | null;
  TestQuestionDifficultyLevelTypeCode: string ;
  TestSequenceNumber?: number | null;
  TestTypeCode?: string;
  TotalScore?: number;
  UDTMockExamApplicableCoursePlan: IApplicableCoursePlan[];
}

export interface IWeeklyPracticeTestPayload {
  AvailableDate: string
  CourseId: number
  CourseTestId: any
  CourseTestStatusTypeCode: string
  ExamSeriesTypeCode?: string|null
  LoggedInUser: string
  NumberOfQuestions: number
  StudentId?: any
  TestName: string
  TestQuestionDifficultyLevelTypeCode: string
  TestSequenceNumber: any
  TestTypeCode: string
  TotalScore: number
  UDTMockExamApplicableCoursePlan: UdtmockExamApplicableCoursePlan[]
}

export interface UdtmockExamApplicableCoursePlan {
  CoursePlanID: number
  SelectedInd: string
}
export interface IgetMockExamApplicableCoursePlanPayload {
  LoggedInUser?: string;
  SessionLanguageTypeCode?: string;
  ScreenName: string ;
  CourseTestID?: number | null;
  CourseID?: number;
  CoursePlanID?: number | null;
  SelectedInd: string | null;
}
export interface IgetWeeklyPracticeTestApplicableCoursePlanPayload {
  LoggedInUser?: string;
  SessionLanguageTypeCode?: string;
  ScreenName: string | null ;
  CourseTestID?: number | null;
  CourseID?: number;
  CoursePlanID?: number | null;
  SelectedInd: string | null;
}
export interface IMockQuestionRequest {
  LoggedInUser?: string;
  CourseTestId: number;
  CourseTestStatusTypeCode: string | null;
}
export interface IMockExamQuestion {
  Exam_Agency_Name: string;
  Course_Name: string;
  Exam_Short_Name: string;
  Exam_Year: number;
  Course_Test_Id: number;
  Test_Sequence_Number: number;
  Subject_Id: number;
  Subject_Name: string;
  Total_Number_Of_Question: number;
  Current_Number_Of_Question: number;
  Subject_Total_Number_Of_Question: number;
  Subject_Current_Number_Of_Question: number;
  Path_Name: string;
  Question_ID: string;
  Question_Text: string;
  Answer_Choice_Sequence_Number: number;
  Answer_Choice_Id: number;
  Answer_Choice_Text: string;
  Right_Answer_Ind: string;
  All_Of_The_Above_Or_None_Of_The_Above_Ind: string;
  isCollapsed?: boolean;
  Selected_IND: string;
}
export interface IQuestionForMockExam {
  Answer_Selected_IND: string;
  Number_Of_Answer_Choices: number | null;
  Total_Number_Of_Optional_Questions: number | null;
  Time_To_Answer_In_Seconds: number | null;
  Right_Answer_Default_Score: number | null;
  Wrong_Answer_Penalty_Default_Score: number | null;
  Path_Name: string;
  Question_ID: string;
  Question_Text: string;
  Answer_Choice_Id: number;
  Answer_Choice_Text: string;
  Right_Answer_Ind: string;
  All_Of_The_Above_Or_None_Of_The_Above_Ind: string;
}

export interface InsertOrUpdateTestQuestionParams {
  LoggedInUser?: string;
  ErrorMessage?: string;
  SuccessInd?: string;
  UDTTestQuestion: UDTTestQuestionParams[];
  UDTTestQuestionAnswerChoice: UDTTestQuestionAnswerChoiceParams[];
}

export interface UDTTestQuestionParams {
  CourseTestId?: number;
  QuestionId: string;
  QuestionNumber?: number;
  RightAnswerScore?: number;
  WrongAnswerScore?: number;
  TimeToAnswerInSeconds?: number | null;
  OptionalQuestionInd?: string;
  SelectedIND: string;
}

export interface UDTTestQuestionAnswerChoiceParams {
  CourseTestId?: number;
  QuestionId: string;
  AnswerChoiceId?: number;
  AnswerChoiceSequenceNumber?: number;
  SelectedIND: string;
}

@Injectable({
  providedIn: 'root',
})
export class ExamManagementService {
  private handleError: HandleError;
  public url: string;
  public options;
  public ExamAgencyID: any;
  public ExamMasterID: any;
  public ExamInstanceID: any;
  public ExamSubjectID: any;
  public ExamInstanceSubjectID: any;
  public ExamConceptID: any;
  constructor(
    private http: HttpClient,
    private appserv: AppOfflineStore,
    public httpErrorHandler: HttpErrorHandlerService,
    private config: BaseSvcService,
    public session: SessionService
  ) {
    this.handleError = httpErrorHandler.createHandleError('HeroesService');
    this.url = this.config.activeURL;
    this.options = this.config._httpoption;
  }
  private selectedExamIdSubject = new BehaviorSubject<number | null>(null);
  selectedExamId$ = this.selectedExamIdSubject.asObservable();

  setSelectedExamId(id: number | null) {
    this.selectedExamIdSubject.next(id);
  }

  clearSelectedExamId() {
    this.selectedExamIdSubject.next(null);
  }

  // MOCK EXAM ENDPOINTS START
  getMockExams(payload: IMockExamRequest): Observable<IMockExam[]> {
    // Ensure LoggedinUser is assigned correctly
    const updatedPayload: IMockExamRequest = {
      ...payload,
      LoggedInUser: this.session.getUser(),
    };

    return this.http
      .post<IMockExam[]>(`${this.url}/api/GetMockExam`, updatedPayload)
      .pipe(map((e: any) => e.mockExamReult));
  }

  getMockExamsStatusTypes(): Observable<any[]> {
    return this.http
      .get<{ resultList: any[] }>(
        `${this.url}api/GetCodes/COURSE_TEST_STATUS_TYPE`,
        this.options
      )
      .pipe(map((response) => response.resultList));
  }

  getMockExamApplicableCoursePlan(
    payload: IgetMockExamApplicableCoursePlanPayload
  ) {
    payload.LoggedInUser = this.session.getUser();
    payload.SessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .post<ICoursePlanMockExam[] | null>(
        `${this.url}/api/GetMockExamApplicableCoursePlan`,
        payload
      )
      .pipe(map((e: any) => e.ResultList));
  }
  getMockExamQuestion(payload: IMockQuestionRequest) {
    payload.LoggedInUser = this.session.getUser();
    return this.http
      .post<any[] | null>(`${this.url}api/GetMockExamQuestion`, payload)
      .pipe(map((e: any) => this.ExtractMockExamQuestions(e.ResultList)));
  }
  insertOrUpdateTestQuestion(
    data: InsertOrUpdateTestQuestionParams
  ): Observable<any> {
    data.LoggedInUser = this.session.getUser();
    return this.http.post<any>(
      `${this.url}api/InsertOrUpdateTestQuestion`,
      data
    );
  }
  getQuestionForMockExam$(
    payload: IGetMockExamQuestionRequest
  ): Observable<any[]> {
    payload.LoggedInUser = this.session.getUser();
    return this.http
      .post<any[]>(this.url + 'api/GetQuestionForMockExam', payload)
      .pipe(map((e: any) => this.ExtractQuestionsForMockExam(e.ResultList)));
  }

  ExtractMockExamQuestions(apiResponse: IMockExamQuestion[]) {
    const subjectsMap = new Map();
    apiResponse.forEach((item) => {
      if (!subjectsMap.has(item.Subject_Id)) {
        subjectsMap.set(item.Subject_Id, {
          Subject_Id: item.Subject_Id,
          Subject_Name: item.Subject_Name,
          Subject_Total_Number_Of_Question:
            item.Subject_Total_Number_Of_Question,
          Subject_Current_Number_Of_Question:
            item.Subject_Current_Number_Of_Question,
          Total_Number_Of_Question: item.Total_Number_Of_Question,
          Current_Number_Of_Question: item.Current_Number_Of_Question,
          isCollapsed: true,
          questions: new Map(),
        });
      }
      if (item.Question_ID) {
        const subject = subjectsMap.get(item.Subject_Id);
        if (!subject.questions.has(item.Question_ID)) {
          subject.questions.set(item.Question_ID, {
            Path_Name: item.Path_Name,
            Question_ID: item.Question_ID,
            Question_Text: item.Question_Text,
            Answer_Choices: [],
          });
        }
        subject.questions.get(item.Question_ID).Answer_Choices.push({
          Answer_Choice_Sequence_Number: item.Answer_Choice_Sequence_Number,
          Answer_Choice_Id: item.Answer_Choice_Id,
          Answer_Choice_Text: item.Answer_Choice_Text,
          Right_Answer_Ind: item.Right_Answer_Ind,
          All_Of_The_Above_Or_None_Of_The_Above_Ind:
            item.All_Of_The_Above_Or_None_Of_The_Above_Ind,
          Selected_IND: item.Selected_IND,
        });
      }
    });
    return Array.from(subjectsMap.values()).map((subject) => {
      subject.questions = Array.from(subject.questions.values());
      return subject;
    });
  }

  ExtractQuestionsForMockExam(apiResponse: IQuestionForMockExam[]) {
    const QuestionMap = new Map();
    apiResponse.forEach((item) => {
      if (!QuestionMap.has(item.Question_ID)) {
        QuestionMap.set(item.Question_ID, {
          Path_Name: item.Path_Name,
          Question_ID: item.Question_ID,
          Question_Text: item.Question_Text,
          Answer_Choices: [],
          SelectedQuestion: false,
          Number_Of_Answer_Choices: item.Number_Of_Answer_Choices,
          Right_Answer_Default_Score: item.Right_Answer_Default_Score,
          RightAnswerDefaultScore: item.Right_Answer_Default_Score,
          Wrong_Answer_Penalty_Default_Score:
            item.Wrong_Answer_Penalty_Default_Score,
          WrongAnswerPenaltyDefaultScore:
            item.Wrong_Answer_Penalty_Default_Score,
          Time_To_Answer_In_Seconds: item.Time_To_Answer_In_Seconds,
          TimeToAnswerInSeconds: item.Time_To_Answer_In_Seconds,
          Total_Number_Of_Optional_Questions:
            item.Total_Number_Of_Optional_Questions,
        });
      }
      QuestionMap.get(item.Question_ID).Answer_Choices.push({
        Answer_Choice_Id: item.Answer_Choice_Id,
        Answer_Choice_Text: item.Answer_Choice_Text,
        Right_Answer_Ind: item.Right_Answer_Ind,
        All_Of_The_Above_Or_None_Of_The_Above_Ind:
          item.All_Of_The_Above_Or_None_Of_The_Above_Ind,
        Answer_Selected_IND: item.Answer_Selected_IND,
        selected: item.Right_Answer_Ind === 'Y' ? true : false,
      });
    });
    return Array.from(QuestionMap.values()).map((question) => {
      return question;
    });
  }

  addEditMockExam(payload: IMockExampayload) {
    const updatedPayload: IMockExampayload = {
      ...payload,
      LoggedInUser: this.session.getUser(),
    };
    return this.http.post<any>(
      `${this.url}/api/InsertOrUpdateCourseTest`,
      updatedPayload
    );
  }
  // MOCK EXAM ENDPOINTS END

  // WEEKLY PRACTICE TEST ENDPOINTS START
  getWeeklyPracticeTest(payload: IWeeklyPracticeTestRequest): Observable<IPracticeTest[]> {
    // Ensure LoggedinUser is assigned correctly
    const updatedPayload: IWeeklyPracticeTestRequest = {
      ...payload,
      LoggedInUser: this.session.getUser(),
    };

    return this.http
      .post<IPracticeTest[]>(`${this.url}/api/GetPracticeTest`, updatedPayload)
      .pipe(map((e: any) => e.data));
  }

  getWeeklyPracticeTestStatusTypes(): Observable<any[]> {
    return this.http
      .get<{ resultList: any[] }>(
        `${this.url}api/GetCodes/COURSE_TEST_STATUS_TYPE`,
        this.options
      )
      .pipe(map((response) => response.resultList));
  }

  getWeeklyPracticeTestApplicableCoursePlan(
    payload: IgetWeeklyPracticeTestApplicableCoursePlanPayload
  ) {
    payload.LoggedInUser = this.session.getUser();
    payload.SessionLanguageTypeCode = this.appserv.userlanuage;
    return this.http
      .post<ICoursePlanMockExam[] | null>(
        `${this.url}/api/GetPracticeTestApplicableCoursePlan`,
        payload
      )
      .pipe(map((e: any) => e.data));
  }
  getWeeklyPracticeTestQuestion(payload: IMockQuestionRequest) {
    payload.LoggedInUser = this.session.getUser();
    return this.http
      .post<any[] | null>(`${this.url}api/GetPracticeTestQuestion`, payload)
      .pipe(map((e: any) => this.ExtractMockExamQuestions(e.data)));
  }
  insertOrUpdateTestQuestionPracticeTestWeekly(
    data: InsertOrUpdateTestQuestionParams
  ): Observable<any> {
    data.LoggedInUser = this.session.getUser();
    return this.http.post<any>(
      `${this.url}api/InsertOrUpdateTestQuestion`,
      data
    );
  }
  getQuestionForWeeklyPracticeTest$(
    payload: IGetMockExamQuestionRequest
  ): Observable<any[]> {
    payload.LoggedInUser = this.session.getUser();
    return this.http
      .post<any[]>(this.url + 'api/GetQuestionForPracticeTest', payload)
      .pipe(map((e: any) => this.ExtractQuestionsForMockExam(e.data)));
  }

  ExtractWeeklyPracticeTestQuestions(apiResponse: IMockExamQuestion[]) {
    const subjectsMap = new Map();
    apiResponse.forEach((item) => {
      if (!subjectsMap.has(item.Subject_Id)) {
        subjectsMap.set(item.Subject_Id, {
          Subject_Id: item.Subject_Id,
          Subject_Name: item.Subject_Name,
          Subject_Total_Number_Of_Question:
            item.Subject_Total_Number_Of_Question,
          Subject_Current_Number_Of_Question:
            item.Subject_Current_Number_Of_Question,
          Total_Number_Of_Question: item.Total_Number_Of_Question,
          Current_Number_Of_Question: item.Current_Number_Of_Question,
          isCollapsed: true,
          questions: new Map(),
        });
      }
      if (item.Question_ID) {
        const subject = subjectsMap.get(item.Subject_Id);
        if (!subject.questions.has(item.Question_ID)) {
          subject.questions.set(item.Question_ID, {
            Path_Name: item.Path_Name,
            Question_ID: item.Question_ID,
            Question_Text: item.Question_Text,
            Answer_Choices: [],
          });
        }
        subject.questions.get(item.Question_ID).Answer_Choices.push({
          Answer_Choice_Sequence_Number: item.Answer_Choice_Sequence_Number,
          Answer_Choice_Id: item.Answer_Choice_Id,
          Answer_Choice_Text: item.Answer_Choice_Text,
          Right_Answer_Ind: item.Right_Answer_Ind,
          All_Of_The_Above_Or_None_Of_The_Above_Ind:
            item.All_Of_The_Above_Or_None_Of_The_Above_Ind,
          Selected_IND: item.Selected_IND,
        });
      }
    });
    return Array.from(subjectsMap.values()).map((subject) => {
      subject.questions = Array.from(subject.questions.values());
      return subject;
    });
  }

  ExtractQuestionsForWeeklyPracticeTest(apiResponse: IQuestionForMockExam[]) {
    const QuestionMap = new Map();
    apiResponse.forEach((item) => {
      if (!QuestionMap.has(item.Question_ID)) {
        QuestionMap.set(item.Question_ID, {
          Path_Name: item.Path_Name,
          Question_ID: item.Question_ID,
          Question_Text: item.Question_Text,
          Answer_Choices: [],
          SelectedQuestion: false,
          Number_Of_Answer_Choices: item.Number_Of_Answer_Choices,
          Right_Answer_Default_Score: item.Right_Answer_Default_Score,
          RightAnswerDefaultScore: item.Right_Answer_Default_Score,
          Wrong_Answer_Penalty_Default_Score:
            item.Wrong_Answer_Penalty_Default_Score,
          WrongAnswerPenaltyDefaultScore:
            item.Wrong_Answer_Penalty_Default_Score,
          Time_To_Answer_In_Seconds: item.Time_To_Answer_In_Seconds,
          TimeToAnswerInSeconds: item.Time_To_Answer_In_Seconds,
          Total_Number_Of_Optional_Questions:
            item.Total_Number_Of_Optional_Questions,
        });
      }
      QuestionMap.get(item.Question_ID).Answer_Choices.push({
        Answer_Choice_Id: item.Answer_Choice_Id,
        Answer_Choice_Text: item.Answer_Choice_Text,
        Right_Answer_Ind: item.Right_Answer_Ind,
        All_Of_The_Above_Or_None_Of_The_Above_Ind:
          item.All_Of_The_Above_Or_None_Of_The_Above_Ind,
        Answer_Selected_IND: item.Answer_Selected_IND,
        selected: item.Right_Answer_Ind === 'Y' ? true : false,
      });
    });
    return Array.from(QuestionMap.values()).map((question) => {
      return question;
    });
  }

  addEditWeeklyPracticeTest(payload: IWeeklyPracticeTestPayload) {
    const updatedPayload: IWeeklyPracticeTestPayload = {
      ...payload,
      LoggedInUser: this.session.getUser(),
    };
    return this.http.post<any>(
      `${this.url}/api/InsertOrUpdateCourseTest`,
      updatedPayload
    );
  }

  getWeeklyPracticeTestStudyUnit(data: any) {
  const updatedPayload = {
      ...data,
      LoggedInUser: this.session.getUser(),
    };
    return this.http.post(`${this.url}/api/GetPracticeTestStudyUnit`, updatedPayload).pipe(
      map((e: any) => e.data)
    );
  }

  insertUpdateWeeklyPracticeTestStudyUnit(data: IInsertUpdateWeeklyPracticeTestStudyUnit) {
    const updatedPayload = {
      ...data,
      LoggedInUser: this.session.getUser(),
    };
    return this.http.post(`${this.url}/api/InsertOrUpdatePracticeTestStudyUnit`, updatedPayload);
  }
  getQuestionForPracticeTest(data: IGetQuestionForPracticeTestRequest){
    const updatedPayload:IGetQuestionForPracticeTestRequest = {
      ...data,
      LoggedInUser: this.session.getUser(),
    };
    return this.http.post(`${this.url}/api/GetQuestionForPracticeTest`, updatedPayload);

  }
  // WEEKLY PRACTICE TEST ENDPOINTS END

  getExamInstanceSubject(data: any) {
    return this.http.post(`${this.url}/api/GetCourseSubject`, data);
    // return this.http.post(`${this.url}/api/Get/GetCourseSubject`, data);
  }
  getExamInstanceConcept(data: {
    LoggedInUser: string;
    CourseID: number;
    CourseConceptID: null | number;
    SubjectId: number;
  }) {
    return this.http.post(`${this.url}/api/GetCourseConcept`, data).pipe(
      map((e: any) => {
        return { Data: e.CourseConcepts };
      })
    );
  }
  getExamInstanceConceptSubject(data: {
    LoggedInUser: string;
    CourseSubjectID: number;
  }) {
    return this.http.post(`${this.url}/api/GetCourseConceptSubject`, data).pipe(
      map((e: any) => {
        return { Data: e.CourseConceptSubjects };
      })
    );
  }
  getExamSubjectList(data: any) {
    return this.http.post(`${this.url}/api/GetCourseSubjectSelectList`, data);
  }
  createExamInstanceConcept(data: any) {
    return this.http.post(`${this.url}/api/InsertOrUpdateCourseConcept`, data);
  }
  InsertOrUpdateExamInstanceSubject(data: any) {
    return this.http
      .post<any[]>(
        this.url + 'api/InsertOrUpdateCourseSubject',
        data,
        // this.options
      )
      .pipe(catchError(this.handleError('getQuestion', [])));
  }

  GetCode(data: { Tablename: string }): Observable<any[]> {
    return this.http
      .get<{ resultList: any[] }>(
        `${this.url}api/GetCodes/${data.Tablename}`,
        this.options
      )
      .pipe(
        map((response) => response.resultList),
        catchError(this.handleError<any[]>('getQuestion', []))
      );
  }

  GetCodeCourse(data: { Tablename: string }): Observable<any[]> {
    return this.http
      .get<{ resultList: any[] }>(
        `${this.url}api/GetCodes/${data.Tablename}`,
        this.options
      )
      .pipe(
        map((response) => response.resultList),
        catchError(this.handleError<any[]>('getQuestion', []))
      );
  }

  getExamSeriesType() {
    return this.http
      .get<{ resultList: any[] }>(
        `${this.url}api/GetCodes/EXAM_SERIES_TYPE`,
        this.options
      )
      .pipe(
        map((response) => response.resultList),
        catchError(this.handleError<any[]>('getQuestion', []))
      );
  }
}
